import { render, staticRenderFns } from "./10.vue?vue&type=template&id=081d9ede&scoped=true&"
var script = {}
import style0 from "./10.vue?vue&type=style&index=0&id=081d9ede&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081d9ede",
  null
  
)

export default component.exports